import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { TemplateWrapperComponent } from './template-wrapper.component';
import { TemplateManageComponent } from './template-manage';
import { TemplateModifyComponent } from './template-modify';

const templateRoutes: Routes = [
   {
      path: '',
      component: TemplateWrapperComponent,
      children: [
         {
            path: ':action/:id',
            component: TemplateModifyComponent
         },
         {
            path: ':action',
            component: TemplateModifyComponent
         },
         {
            path: '',
            component: TemplateManageComponent
         }
      ]
   }
];

@NgModule({
   imports: [ RouterModule.forChild( templateRoutes )],
   exports: [ RouterModule ]
})
export class TemplateRouterModule { }
